// extracted by mini-css-extract-plugin
module.exports = {"bp3-popover-content":"ConsignmentRow_bp3-popover-content__1QS88","bp3-dialog":"ConsignmentRow_bp3-dialog__1DmAp","consignmentRow":"ConsignmentRow_consignmentRow__9WB6D"};